import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const talewavePaymentConfig: BrandPaymentConfig = {
  brand: 'talewave',

  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/talewave/welfare-gold.png',
    },
  },

  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/talewave/vip_bg.webp',
      memberSubscribeBg: '/images/talewave/member_subscribe_bg.webp',
      vipIcon: '/images/talewave/vip_icon2.png',
      vipDiscountIcon: '/images/talewave/vip_discount.png',
      discountBg: '/images/talewave/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
      purpleTextGradient: 'linear-gradient(180deg, #BEA9FF 0%, #D3C5FB 70%, #F3EFFF 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
    },
  },

  chapter: {
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #6B92FD, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#FF873F',
      coinsPopupText3: '#65686F',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#EDF2FF',
      subscribeActiveBg: '#F3F5FA',
      purpleTextGradient: 'linear-gradient(180deg, #A3BBFF 0%, #C6D1ED 70%, #F3F5FA 100%)',
      pinkGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
      memberSubscribeBg: '/images/talewave/chapter/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}

export default talewavePaymentConfig
